import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { FontVariant } from "../../constants/fonts";

const Container = styled.div`
  flex: 1;
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ThemeContainer = styled.div`
  width: 100%;
  padding: 5px 20px 5px 20px;
  p {
    margin: 0px;
    margin-bottom: 5px;
  }
`;

const Surface = styled.div`
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-direction: column;
`;

const SurfaceContent = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export default function SurfacePreviews() {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { secondary, primary, tertiary } = values;
  const {
    color: PrimaryColor,
    surfaces: PrimarySurfaces,
    content: PrimaryContent,
  } = primary;
  const {
    color: SecondaryColor,
    surfaces: SecondarySurfaces,
    content: SecondaryContent,
  } = secondary;
  const {
    color: TertiaryColor,
    surfaces: TertiarySurfaces,
    content: TertiaryContent,
  } = tertiary;

  return (
    <Container>
      <ThemeContainer style={{ backgroundColor: PrimaryColor }}>
        <p
          style={{
            color: PrimaryContent.default,
          }}
        >
          Primary Surfaces
        </p>
        <Surface style={{ backgroundColor: PrimarySurfaces.default.color }}>
          <SurfaceContent
            style={{
              color: PrimarySurfaces.default.content.default,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content Default
          </SurfaceContent>
        </Surface>
        <Surface style={{ backgroundColor: PrimarySurfaces.alt_1.color }} />
      </ThemeContainer>
      <ThemeContainer style={{ backgroundColor: SecondaryColor }}>
        <p
          style={{
            color: SecondaryContent.default,
          }}
        >
          Secondary Surfaces
        </p>
        <Surface style={{ backgroundColor: SecondarySurfaces.default.color }}>
          <SurfaceContent
            style={{
              color: SecondarySurfaces.default.content.default,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content Default
          </SurfaceContent>
          <SurfaceContent
            style={{
              color: SecondarySurfaces.default.content.alt_1,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content 1
          </SurfaceContent>
        </Surface>
      </ThemeContainer>
      <ThemeContainer style={{ backgroundColor: TertiaryColor }}>
        <p
          style={{
            color: TertiaryContent.default,
          }}
        >
          Tertiary Surfaces
        </p>
        <Surface style={{ backgroundColor: TertiarySurfaces.default.color }}>
          <SurfaceContent
            style={{
              color: TertiarySurfaces.default.content.default,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content Default
          </SurfaceContent>
          <SurfaceContent
            style={{
              color: TertiarySurfaces.default.content.alt_1,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content 1
          </SurfaceContent>
          <SurfaceContent
            style={{
              color: TertiarySurfaces.default.content.alt_2,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            Surface Content 2
          </SurfaceContent>
        </Surface>
      </ThemeContainer>
    </Container>
  );
}
